import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Шапка с вашим любимым принтом сделана из материала стрейч – разновидности хлопкового полотна: прочного и лёгкого материала, состоящего на 95% из хлопка и на 5% из эластана. За счет вплетения резиновой нити в саму ткань, шапка прекрасно держит форму и практически не мнется; стильно облегает голову. Шапка практична в эксплуатации и будет долго радовать вас любимым принтом.</p><p>Область печати: 180&times;90мм (горизонтально) спереди и сзади шапки.</p><p>Унисекс</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
